import _asyncToGenerator from "/home/girar/.yarn-cache/am-vivacell-menslive-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/girar/.yarn-cache/am-vivacell-menslive-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _wrapAsyncGenerator from "/home/girar/.yarn-cache/am-vivacell-menslive-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _awaitAsyncGenerator from "/home/girar/.yarn-cache/am-vivacell-menslive-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _asyncGeneratorDelegate from "/home/girar/.yarn-cache/am-vivacell-menslive-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate";
import _asyncIterator from "/home/girar/.yarn-cache/am-vivacell-menslive-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncIterator";
export var streamChunk =
/*#__PURE__*/
_regeneratorRuntime.mark(function streamChunk(chunk, chunkSize) {
  var len, pos, end;
  return _regeneratorRuntime.wrap(function streamChunk$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          len = chunk.byteLength;

          if (!(!chunkSize || len < chunkSize)) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return chunk;

        case 4:
          return _context.abrupt("return");

        case 5:
          pos = 0;

        case 6:
          if (!(pos < len)) {
            _context.next = 13;
            break;
          }

          end = pos + chunkSize;
          _context.next = 10;
          return chunk.slice(pos, end);

        case 10:
          pos = end;
          _context.next = 6;
          break;

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, streamChunk);
});
export var readBytes =
/*#__PURE__*/
function () {
  var _ref = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(iterable, chunkSize) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context2.prev = 2;
            _iterator = _asyncIterator(readStream(iterable));

          case 4:
            _context2.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            _step = _context2.sent;
            _iteratorNormalCompletion = _step.done;
            _context2.next = 10;
            return _awaitAsyncGenerator(_step.value);

          case 10:
            _value = _context2.sent;

            if (_iteratorNormalCompletion) {
              _context2.next = 17;
              break;
            }

            chunk = _value;
            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(streamChunk(chunk, chunkSize)), _awaitAsyncGenerator), "t0", 14);

          case 14:
            _iteratorNormalCompletion = true;
            _context2.next = 4;
            break;

          case 17:
            _context2.next = 23;
            break;

          case 19:
            _context2.prev = 19;
            _context2.t1 = _context2["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 23:
            _context2.prev = 23;
            _context2.prev = 24;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context2.next = 28;
              break;
            }

            _context2.next = 28;
            return _awaitAsyncGenerator(_iterator.return());

          case 28:
            _context2.prev = 28;

            if (!_didIteratorError) {
              _context2.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context2.finish(28);

          case 32:
            return _context2.finish(23);

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[2, 19, 23, 33], [24,, 28, 32]]);
  }));

  return function readBytes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var readStream =
/*#__PURE__*/
function () {
  var _ref2 = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(stream) {
    var reader, _ref3, done, value;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!stream[Symbol.asyncIterator]) {
              _context3.next = 3;
              break;
            }

            return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(stream), _awaitAsyncGenerator), "t0", 2);

          case 2:
            return _context3.abrupt("return");

          case 3:
            reader = stream.getReader();
            _context3.prev = 4;

          case 5:
            _context3.next = 7;
            return _awaitAsyncGenerator(reader.read());

          case 7:
            _ref3 = _context3.sent;
            done = _ref3.done;
            value = _ref3.value;

            if (!done) {
              _context3.next = 12;
              break;
            }

            return _context3.abrupt("break", 16);

          case 12:
            _context3.next = 14;
            return value;

          case 14:
            _context3.next = 5;
            break;

          case 16:
            _context3.prev = 16;
            _context3.next = 19;
            return _awaitAsyncGenerator(reader.cancel());

          case 19:
            return _context3.finish(16);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[4,, 16, 20]]);
  }));

  return function readStream(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

export var trackStream = function trackStream(stream, chunkSize, onProgress, onFinish) {
  var iterator = readBytes(stream, chunkSize);
  var bytes = 0;
  var done;

  var _onFinish = function _onFinish(e) {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    pull: function () {
      var _pull = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(controller) {
        var _ref4, _done, value, len, loadedBytes;

        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return iterator.next();

              case 3:
                _ref4 = _context4.sent;
                _done = _ref4.done;
                value = _ref4.value;

                if (!_done) {
                  _context4.next = 10;
                  break;
                }

                _onFinish();

                controller.close();
                return _context4.abrupt("return");

              case 10:
                len = value.byteLength;

                if (onProgress) {
                  loadedBytes = bytes += len;
                  onProgress(loadedBytes);
                }

                controller.enqueue(new Uint8Array(value));
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](0);

                _onFinish(_context4.t0);

                throw _context4.t0;

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, null, [[0, 15]]);
      }));

      return function pull(_x4) {
        return _pull.apply(this, arguments);
      };
    }(),
    cancel: function cancel(reason) {
      _onFinish(reason);

      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};